import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array, TArrayCodec } from "../../../shared/src/codecs/types/array";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { Party1Editable, PartyReadOnly1, TParty1EditableCodec, TPartyReadOnly1Codec } from "../Party";
import { PartyId, TPartyIdCodec } from "../PartyId";
import { AddPartyListingForm, TAddPartyListingFormCodec } from "../form/AddPartyListingForm";
import { PartyMemberCreateForm, TPartyMemberCreateFormCodec } from "../form/PartyMemberCreateForm";
import { ListingSellerUserEditForm, TListingSellerUserEditFormCodec } from "../form/ListingSellerUserEditForm";
import { NewUserNumberFormIO, TNewUserNumberFormIOCodec } from "./NewUserNumberFormIO";
import { RemoveUserNumberFormIO, TRemoveUserNumberFormIOCodec } from "./RemoveUserNumberFormIO";

export const PartyDataFormIO: TFormIOCodec<
    TPartyIdCodec,
    TRequiredCodec<{
        read_only: TPartyReadOnly1Codec;
        form: TParty1EditableCodec;
        members: TArrayCodec<TListingSellerUserEditFormCodec>;
        member_create: TPartyMemberCreateFormCodec;
        member_phone_number_create: TNewUserNumberFormIOCodec;
        member_phone_number_delete: TRemoveUserNumberFormIOCodec;
        add_listing: TAddPartyListingFormCodec;
    }>
> = formIO(
    PartyId,
    required({
        read_only: PartyReadOnly1,
        form: Party1Editable,
        members: array(ListingSellerUserEditForm),
        member_create: PartyMemberCreateForm,
        member_phone_number_create: NewUserNumberFormIO,
        member_phone_number_delete: RemoveUserNumberFormIO,
        add_listing: AddPartyListingForm,
    }),
);

export type TPartyDataFormIOCodec = typeof PartyDataFormIO;
export type TPartyDataFormIO = TTypeOfCodec<TPartyDataFormIOCodec>;
